<div class="back" [style.margin-left]="marginLeft? marginLeft:''">
    <a [routerLink]="href" data-action="headerBack">
        <i class="icon-left-2"></i>
        <span><ng-content></ng-content></span>
    </a>
</div>
